import Api from "../config/Axios";

export const getNotificationList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.get("api/web/notifications",{params:data, ...config});
};

export const getNotificationSingle = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/notification/${id}`, config);
};

export const postNotificationAdd = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.post(`api/web/notification`, data, config);
};



// Categories Services
export const getCategoriesList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get("api/web/notification/categories",{params:data, ...config});
};

export const getCategoriesSingle = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/notification/category/${id}`, config);
};

export const patchCategoriesEdit = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/notification/category/${id}`, data, config);
};

export const postCategoriesAdd = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.post(`api/web/notification/category`, data, config);
};

export const deleteCategoriesDelete = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.delete(`api/web/notification/category/${id}`, config);
};